/*eslint-disable react/jsx-no-target-blank */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
import { Col, Container, ListGroup, Row } from 'react-bootstrap';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import {
  FacebookSVG,
  TwitterSVG,
  LinkedinSVG,
  YoutubeSVG,
} from '../../img/FooterSVG';
library.add(faExclamationCircle);

export default function Footer() {
  return (
    <div className="footer">
      <Container>
        <Row>
          <Col md={12} lg={12} sm={12} xs={12} className="width-100">
            <h3>Connect with us</h3>
            <ListGroup horizontal>
              <ListGroup.Item>
                <a
                  href="https://www.facebook.com/MphasisOfficial/"
                  target="_blank"
                  alt="facebook"
                  title="Facebook"
                >
                  {/*<i className="fab fa-facebook-f"></i> */}
                  <FacebookSVG />
                </a>
              </ListGroup.Item>
              <ListGroup.Item>
                <a
                  href="https://twitter.com/mphasis"
                  target="_blank"
                  alt="Twitter"
                  title="Twitter"
                >
                  {/*<i className="fab fa-twitter"></i> */}
                  <TwitterSVG />
                </a>
              </ListGroup.Item>
              <ListGroup.Item>
                <a
                  href="https://www.youtube.com/user/MphasisOfficial"
                  target="_blank"
                  alt="YouTube"
                  title="YouTube"
                >
                  {/*<i className="fab fa-youtube"></i> */}
                  <YoutubeSVG />
                </a>
              </ListGroup.Item>
              <ListGroup.Item>
                <a
                  href="https://www.linkedin.com/organization-guest/company/mphasis/"
                  target="_blank"
                  alt="LinkedIn"
                  title="LinkedIn"
                >
                  {/*<i className="fab fa-linkedin-square"></i> */}
                  <LinkedinSVG />
                </a>
              </ListGroup.Item>
            </ListGroup>
          </Col>
        </Row>
        <p className="copy-right">
          © 2005 - 2022 copyright of Javelina Insurance Company, Inc.
        </p>
      </Container>
    </div>
  );
}
